<template>
  <div>
<!--    <COM_HeaderNav mode="OnePageAdv2"></COM_HeaderNav>-->

    <MyToolbarVuetify class="bk_toolbar_fixed-top" ref="myToolbar" :grid-select-ids="gridSelectIds"  v-on:button-click="toolbarButton_Click" > </MyToolbarVuetify>

    <div class="bk_firstBlock"/>

    <MyVueEasytable ref="grid" v-on:grid-selected="grid_Selected"></MyVueEasytable>

  </div>
</template>

<script>

import apiUBossShopBk from "@/pages/ubossBk/util/apiUBossShopBk";
// import COM_HeaderNav from "@/pages/ubossBk/views/components/COM_HeaderNav.vue";
import MyToolbarVuetify from "@/pages/commonComponent/MyToolbarVuetify.vue";
import MyVueEasytable from "@/pages/commonComponent/MyVueEasytable/MyVueEasytable.vue";
import {
  MyVueEasyGrid,
  MyVueEasyGridExpandForm,  MyVueEasyGridUtility
} from "@/pages/commonComponent/MyVueEasytable/js/MyVueEasytable";
import {MyToolbar, MyToolbarGroup} from "@/pages/commonComponent/js/MyToolbarVuetify";
import {MyToolbarButtonIdEnum} from "@/pages/commonComponent/js/MyToolbarVuetify";

export default {
  components: {
    MyVueEasytable,
    MyToolbarVuetify
  },
  data: function () {
    return {
      datas:[
        {
          SystemId: "1",
          cname: "www",
          memo: "",
          createDt:"2023-07-01",
          modifyDt:"2023-07-01",
        },
        {
          SystemId: "2",
          cname: "vip",
          memo: "",
          createDt:"2023-07-01",//QQ
          modifyDt:"2023-07-01",
        },
      ],
      gridSelectIds:{},
    };
  },
  methods: {
    async loadData() {
      this.datas=await apiUBossShopBk.api_Member_ListQuery(null)
    },
    initGrid(){
      //Expand顯示的資訊
      let gridExpandForm = new MyVueEasyGridExpandForm();

      gridExpandForm.addItem("createDt", "建立時間");//QQ
      gridExpandForm.addItem("modifyDt", "修改時間");

      //Render Method
      let gridUtility = new MyVueEasyGridUtility();

      // let funRenderHyperLink = gridUtility.GetFun_RenderHyperLink("test-text", (row) => row.name, (row) => "http://github.com/" + row.name);
      let funRenderExpandForm=gridUtility.GetFun_RenderExpandForm(gridExpandForm.Items);

      //欄位
      let grid = new MyVueEasyGrid(this.$refs.grid)
          .addColumnSeq()
          .addColumnExpand()
          .addColumnCheckBox()
          .addColumn("CName名稱", "cname")
          .addColumn("備註", "memo")//QQ
          .addColumn("建立時間", "createDt",true)
          .addColumn("修改時間", "modifyDt",true)
      ;

      //設定Grid
      this.$refs.grid.set_expandOption(funRenderExpandForm);
      this.$refs.grid.set_columns(grid.Columns);
      this.$refs.grid.set_tableData(this.datas);
      this.$refs.grid.set_mobileUI();

      //Grid Doc
      // //Radio
      // this.$refs.grid.gridUtil_RadioSelectById["1"]
      // this.$refs.grid.gridUtil_RadioUnSelect(["1"])
      //
      // //Checkbox
      // this.$refs.grid.gridUtil_CheckboxSelectAll();
      // this.$refs.grid.gridUtil_UnCheckboxSelectAll();
      //
      // //Column
      // this.$refs.grid.gridUtil_ShowColumnsByKeys(["name"])
      // this.$refs.grid.gridUtil_HideColumnsByKeys(["name"])
      //
      // //Other
      // this.$refs.grid.gridUtil_ShowEmpty();
      //
      // //Get Info
      // this.info="";
      // this.info+="All:"+this.$refs.grid.gridUtil_SelectedIds();
      // this.info+="R:"+this.$refs.grid.gridUtil_RadioSelectedId();
      // this.info+="C:"+this.$refs.grid.gridUtil_CheckBoxSelectedIds();
    },
    initToolbar(){
      let toolbarGroup1=new MyToolbarGroup();
      toolbarGroup1
          .addButton_BackDefault()
          .addButton_Add()
          .addButton_Edit()
          .addButton_Delete()
          .addButton_Copy()//
      ;

      let toolbar=new MyToolbar();

      toolbar.addGroup(toolbarGroup1);

      this.$refs.myToolbar.setProp_Toolbar(toolbar);
    },
    toolbarButton_Click(buttonId,selectIds){  // eslint-disable-line
      if (buttonId===MyToolbarButtonIdEnum.Add){
        console.log("");
      }else if (buttonId===MyToolbarButtonIdEnum.Edit){
        this.$router.push({ name: 'OnePageAdvIndexCName', query: { SystemId: 0 }})
      }

      // alert(buttonId);
      // alert(selectIds);
    },
    grid_Selected(selectedIds){
      this.gridSelectIds=selectedIds;
    }
  },
  created() {
    console.log("page create start");

    console.log("page create end");
  },
  mounted() {
    console.log("page mount start");
    this.loadData();
    this.initGrid();
    this.initToolbar();
    console.log("page mount end");
  },
}
</script>

<style scoped>

</style>
